import {
  getTenantFromUrl,
  ETenantCode,
} from '@digital-platform/tenant-resolver-lib';

export const isCareplus =
  getTenantFromUrl(window.location.href) === ETenantCode.CAREPLUS;
